import React, { Component } from 'react';
import { Platform } from 'react-native'
import PropTypes from "prop-types"

import MapWeb from './MapWeb'
import MapRN from './MapRN'

export default class ThumbnailMap extends Component {
	static propTypes = {
		addressLat: PropTypes.string,
		addressLon: PropTypes.string,
		plotName: PropTypes.string,
		plotAddress: PropTypes.string,
		onMapPress: PropTypes.func,
		pageShowMap:  PropTypes.bool,
	}
	render() {
		const mapData = this.props
		const addressLat = Number(mapData.addressLat)
		const addressLon = Number(mapData.addressLon)
		const plotName = mapData.plotName
		const plotAddress = mapData.plotAddress
		if (Platform.OS == 'web') { // web端
			return (
				<MapWeb pageShowMap={mapData.pageShowMap} addressLat={addressLat} addressLon={addressLon} latSpace={0.003} plotName={plotName} plotAddress={plotAddress} hasPoint={true} onMapPress={() => {
					if (mapData.onMapPress && typeof mapData.onMapPress === 'function') {
						mapData.onMapPress()
					}
				}} />
			)
		} else { // RN端
			return (
				<MapRN
					pageShowMap={mapData.pageShowMap}
					addressLat={addressLat}
					addressLon={addressLon}
					plotName={plotName}
					plotAddress={plotAddress}
					hasPoint={true}
					onMapPress={() => {
						if (mapData.onMapPress && typeof mapData.onMapPress === 'function') {
							mapData.onMapPress()
						}
					}}
				>
				</MapRN>
			)
		}

	}
}